import merge from 'lodash-es/merge';

import type { SearchOptionsResponse } from '@rover/types';

const searchScoreDebug = {
  category: 'staff_only',
  categoryRank: 10,
  icon: 'na',
  categoryDisplayName: 'Staff Only',
  required: false,
  type: 'boolean',
  rank: 0,
  label: 'Search score popover',
};

const STAFF_ONLY_FILTERS_INDICATOR_FILTER_NAME = 'oralMedication'; // This function adds the search score popover filter since it is not currently being
// supplied by the backend but should be treated as any other staff only filter

const filterShim = (searchOptionsResponse: SearchOptionsResponse): SearchOptionsResponse => {
  if (!searchOptionsResponse.actions.GET) {
    return searchOptionsResponse;
  }

  // SearchOptionsResponse will either have the filterOptions located at actions.GET or
  // actions.GET.[serviceTypeName]. If the filterOptions contain a staff only filter:
  // STAFF_ONLY_FILTERS_INDICATOR_FILTER_NAME, we add the searchScoreDebug filterOption
  if (
    searchOptionsResponse.actions.GET[STAFF_ONLY_FILTERS_INDICATOR_FILTER_NAME] &&
    !searchOptionsResponse.actions.GET.searchScoreDebug
  ) {
    return merge(searchOptionsResponse, {
      actions: {
        GET: {
          searchScoreDebug,
        },
      },
    });
  }

  // If filter options are not top level, check all serviceTypes
  return merge(searchOptionsResponse, {
    actions: {
      GET: Object.entries(searchOptionsResponse.actions.GET).reduce(
        (accum, [serviceTypeName, serviceTypeFilterOptions]: any) => {
          return serviceTypeFilterOptions &&
            serviceTypeFilterOptions[STAFF_ONLY_FILTERS_INDICATOR_FILTER_NAME] &&
            !serviceTypeFilterOptions.searchScoreDebug
            ? { ...accum, [serviceTypeName]: { ...serviceTypeFilterOptions, searchScoreDebug } }
            : { ...accum, [serviceTypeName]: serviceTypeFilterOptions };
        },
        {}
      ),
    },
  });
};

export default filterShim;
